import { useEffect, useState } from "react";
import "./aura-inplay.css";

function MatchDateAndInplay({ inplay, openDate, compactDesign = false }) {
    const matchDate = new Date(openDate);
    const [isNowInPlay, setIsNowInPlay] = useState(() => new Date() >= matchDate);

    useEffect(() => {
        if (inplay || isNowInPlay) return;

        const now = new Date();
        const timeUntilMatch = matchDate - now;

        if (timeUntilMatch <= 0) {
            setIsNowInPlay(true);
            return;
        }

        const timeout = setTimeout(() => {
            setIsNowInPlay(true);
        }, timeUntilMatch);

        return () => clearTimeout(timeout);
    }, [inplay, matchDate, isNowInPlay]);

    if (inplay || isNowInPlay) {
        return (
            <span className="aura-inplay pl-2">
                Inplay
            </span>
        );
    }

    return (
        <span className={`text-xs text-[#777777] font-normal pl-2 whitespace-nowrap`}>
            {matchDate.toLocaleString(undefined, {
                day: "numeric",
                month: "short",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            })}
        </span>
    );
}

export default MatchDateAndInplay;
